import React from "react";
import './fcresult.css';

const getStatusColor = (status) => {
    if (!status) return '#64748b';
    const s = String(status).trim().toUpperCase();
    if (s === 'DISPONIBILE' || s === 'ATTIVO' || s === 'SI' || s === 'YES' || s === '1' || s.includes('OK')) {
        return '#059669'; // VERDE per Attivo / Disponibile
    }
    if (s === 'PIANIFICATO' || s.includes('PIANIFICA')) {
        return '#d97706'; // Arancione per Pianificato
    }
    return '#64748b'; // Grigio neutro per Non disponibile (Mai Rosso)
};

const FibercopResult = (props) => {
    const address = props.address;
    const data = props.data;
    const details = data?.FC?.details;

    if (!details) return null;

    if (Array.isArray(details) && details.length > 1) {
        return (
            <div className="civicListContainer">
                <h4 className="civicListHeader">Civici e Scale Trovate ({details.length})</h4>
                <ul className="civicList">
                    {details.map((item, index) => {
                        const cNum = item.civic || "";
                        return (
                            <li key={index} className="civicListItem">
                                <span>{address} {cNum}</span>
                                {props.onSelectCivic && cNum && (
                                    <button
                                        className="searchCivicBtn"
                                        onClick={() => props.onSelectCivic(cNum)}
                                    >
                                        Cerca Civico
                                    </button>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }

    const ftthStatus = details.COPERTURA_BITSTREAM_NGA_VULA_FTTH || 'Non disponibile';
    const xgsponStatus = details.COPERTURA_BITSTREAM_NGA_VULA_XGSPON || 'Non disponibile';
    const vdslStatus = details.COPERTURA_BITSTREAM_NGA_VULA_FTTCab;
    const evdslStatus = details.COPERTURA_EVDSL_BITSTREAM_NGA_VULA_FTTCab;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {/* Generali */}
            <div className="statGrid">
                {details.DISTANZA_BITSTREAM_NGA_VULA_FTTCab !== undefined && (
                    <div className="statCard">
                        <span className="statLabel">Distanza Armadio</span>
                        <span className="statValue" style={{ color: '#0284c7' }}>{details.DISTANZA_BITSTREAM_NGA_VULA_FTTCab} m</span>
                    </div>
                )}
                {details.FASCIA_CIRCUITI_TERM_ETH_FIBRA_OTTICA && (
                    <div className="statCard">
                        <span className="statLabel">Fibra Dedicata</span>
                        <span className="statValue" style={{ color: '#7e22ce' }}>{details.FASCIA_CIRCUITI_TERM_ETH_FIBRA_OTTICA}</span>
                    </div>
                )}
            </div>

            {/* FTTH */}
            <div>
                <span className="techtTitle" style={{ fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>FTTH / XGS-PON</span>
                <div className="statGrid" style={{ marginTop: '6px' }}>
                    <div className="statCard">
                        <span className="statLabel">1G - 2.5G FTTH</span>
                        <span className="statValue" style={{ color: getStatusColor(ftthStatus) }}>
                            {ftthStatus}
                        </span>
                        {ftthStatus === 'Pianificato' && details.PIANIFICAZIONE_BITSTREAM_NGA_VULA_FTTH && (
                            <span style={{ fontSize: '0.75rem', color: '#d97706', fontWeight: '600' }}>Pianificazione: {details.PIANIFICAZIONE_BITSTREAM_NGA_VULA_FTTH}</span>
                        )}
                    </div>
                    <div className="statCard">
                        <span className="statLabel">10G XGS-PON</span>
                        <span className="statValue" style={{ color: getStatusColor(xgsponStatus) }}>
                            {xgsponStatus}
                        </span>
                        {xgsponStatus === 'Pianificato' && details.PIANIFICAZIONE_BITSTREAM_NGA_VULA_XGSPON && (
                            <span style={{ fontSize: '0.75rem', color: '#d97706', fontWeight: '600' }}>Pianificazione: {details.PIANIFICAZIONE_BITSTREAM_NGA_VULA_XGSPON}</span>
                        )}
                    </div>
                </div>
            </div>

            {/* VDSL & EVDSL */}
            {(vdslStatus || evdslStatus) && (
                <div>
                    <span className="techtTitle" style={{ fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>FTTC / VDSL / EVDSL</span>
                    <div className="statGrid" style={{ marginTop: '6px' }}>
                        {vdslStatus && (
                            <div className="statCard">
                                <span className="statLabel">VDSL (FTTC)</span>
                                <span className="statValue" style={{ color: getStatusColor(vdslStatus) }}>{vdslStatus}</span>
                                {details.VELOCITA_DOWN_BITSTREAM_NGA_VULA_FTTCab && (
                                    <span style={{ fontSize: '0.8rem', color: '#64748b', fontWeight: '600' }}>
                                        Down: {details.VELOCITA_DOWN_BITSTREAM_NGA_VULA_FTTCab} Mb/s | Up: {details.VELOCITA_UP_BITSTREAM_NGA_VULA_FTTCab} Mb/s
                                    </span>
                                )}
                            </div>
                        )}
                        {evdslStatus && (
                            <div className="statCard">
                                <span className="statLabel">EVDSL 200M</span>
                                <span className="statValue" style={{ color: getStatusColor(evdslStatus) }}>{evdslStatus}</span>
                                {details.VELOCITA_DOWN_EVDSL_BITSTREAM_NGA_VULA_FTTCab && (
                                    <span style={{ fontSize: '0.8rem', color: '#64748b', fontWeight: '600' }}>
                                        Down: {details.VELOCITA_DOWN_EVDSL_BITSTREAM_NGA_VULA_FTTCab} Mb/s | Up: {details.VELOCITA_UP_EVDSL_BITSTREAM_NGA_VULA_FTTCab} Mb/s
                                    </span>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default FibercopResult;